import { render } from "./NavigationArrow.vue?vue&type=template&id=7b90eb02&scoped=true"
import script from "./NavigationArrow.vue?vue&type=script&lang=js"
export * from "./NavigationArrow.vue?vue&type=script&lang=js"

import "./NavigationArrow.vue?vue&type=style&index=0&id=7b90eb02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b90eb02"

export default script